export default "__VITE_ASSET__8f7526d2__"